import "./assets/css/artist-all.css";
import React from "react";
import {inject, observer} from "mobx-react";
import {Redirect} from "react-router-dom";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../helpers/validationChecks";
import CategorySection from '../sectionHolders/categorySectionHolder'
import ArtistsAndArtworksSection from '../sectionHolders/artistsAndArtworksCardSection';
import {CountryDropdown} from "react-country-region-selector";

var qs = require('qs')
@inject('userStore', 'artistsListStore', 'categoryPageArtworksStore', 'authStore', 'navigatorStore')
@observer

export default class artist extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emergingArtistsList: false,
            topArtists: false,
            nearByArtists: false,
            keywordCategory: false,
            keywordSearch: false
        }
    }

    componentDidMount() {
        if (localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                result.data[0]

                // if (!result.data[0].interests) {
                //     console.log("interests null")
                //     this.setState({
                //         onboardingOneIncomplete : true
                //     })
                // }
                // if (!result.data[0].preferences) {
                //     console.log("preferences null")
                //     this.setState({
                //         onboardingTwoIncomplete : true
                //     })
                // }
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }
                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        }
        this.props.navigatorStore.artistPageActive(true);
        if (localStorage.hasOwnProperty("userData")) {
            this.getTheData("emerging", "emergingArtistsList", "category");
            this.getTheData("YMC Top", "topArtists", "category");
            this.getTheData("India", "nearByArtists", "search");
            this.getTheData("Featured", "Featured", "category");
        }

        else {
            // this.props.history.replace('/')
            this.props.navigatorStore.openSignInModal();

        }



    }
    selectCountry(item) {
        this.setState({
            changedSomething: true,
            // formInputs: {
            // ...this.state.formInputs,
            country: item
            // }
        })
    }
    componentWillUnmount() {
        if (localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.artistPageActive(false);
        }
    }
    getTheData(keyword, stateKey, identifierForAPI) {
        if (localStorage.hasOwnProperty("userData")) {
            if (identifierForAPI == "category") {
                this.props.artistsListStore.getInitialResultsArtists({ search: keyword })
                    .then((res) => {
                        // console.log(res.data.data)
                        this.setState({
                            [stateKey]: res.data.data
                        })
                    })
            }

            else {

                this.props.artistsListStore.getAllArtists({ search: keyword })
                    .then((res) => {
                        // console.log(res.data.data)
                        this.setState({
                            [stateKey]: res.data.data
                        })
                    })


            }
        }
        else {
            this.props.artistsListStore.getInitialResultsArtistsPublic({ search: keyword })
                .then((res) => {
                    // console.log(res.data.data)
                    this.setState({
                        [stateKey]: res.data.data
                    })
                })
        }
    }

    handleViewAllCountry(item) {
        switch (item) {
            case ("country"): {
                // this.props.categoryPageArtworksStore.setQuery({ search: "featured_artwork" }, "FEATURED ARTWORKS")


                this.setState({
                    viewAllArtistsCountry: true,
                    query: qs.stringify({ search: this.state.country }),
                    artistKeyword: this.state.country,
                    title: "ARTISTS From " + this.state.country
                })
                break;
            }
        }

    }

    handleViewAllBtn(query, title, identifier) {
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        if (identifier == "category") {
            this.props.categoryPageArtworksStore.setQuery({ search: query }, title)
            this.setState({
                keywordCategory: query,
            })
        }

        else {
            this.setState({
                keywordSearch: query
            })
        }
    }


    render() {
        const techniques = [
            { value: "Oil", name: 'OIL', path: require('../../assets/oil.jpg'), colored: true },
            { value: "Acrylic", name: 'ACRYLIC', path: require('../../assets/acrylic.jpg'), colored: true },
            { value: "Watercolor", name: 'WATERCOLOR', path: require('../../assets/watercolor.jpg'), colored: true },
            { value: "Charcoal", name: 'CHARCOAL', path: require('../../assets/charcoal.jpg'), colored: true },
            // { value: "Graphite", name: 'GRAPHITE', path: require('../../assets/watercolor_category.png'), colored: true },
            // { value: "Pencil", name: 'PENCIL', path: require('../../assets/watercolor_category.png'), colored: true },
            // { value: "Mixed", name: 'MIXED', path: require('../../assets/watercolor_category.png'), colored: true },
            // { value: "Pastel", name: 'PASTEL', path: require('../../assets/watercolor_category.png'), colored: true },
            // { value: "Ink", name: 'INK', path: require('../../assets/watercolor_category.png'), colored: true },
        ]
        if (this.state.viewAllArtistsCountry) {
            return (
                <Redirect push to={{ pathname: `/allartists/country/${this.state.country}/${this.state.title}` }} />
            )
        }
        if (this.state.keywordCategory) {
            return (
                <Redirect push to={{ pathname: `/allartists/${this.state.keywordCategory}` }} />

            )
        }
        if (this.state.keywordSearch) {
            return (
                <Redirect push to={{ pathname: `/searchpage_artists/${this.state.keywordSearch}` }} />

            )
        }
        if (this.props.authStore.RegisterSuccess) {
            this.props.authStore.resetRegisterSuccess("onboardingOneIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingTwoIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingThreeIncomplete")
            return (
                <Redirect push to='/onboardingone' />
            )
        }

        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingOneIncomplete) {
            // console.log("redirecting to onboardingOne");
            return (
                <Redirect push to="/onboardingone"></Redirect>
            )
        }
        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingTwoIncomplete) {
            // console.log("redirecting to onboardingTwo");
            return (
                <Redirect push to="/onboardingtwo"></Redirect>
            )
        }
        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingThreeIncomplete) {
            // console.log("redirecting to onboardingThree");
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }
        if (this.state.viewAllArtistsCountry) {
            return (
                <Redirect push to={{ pathname: `/allartists/${this.state.country}/ARTISTS FROM ${this.state.country}/country` }} />
            )
        }
        return (

            <div className="landing-page-container">
                <div className="title-section-artist-page height-315">
                    <div className="title-artist-page ">
                        Artists
                            <hr className="primary-golden-rule"></hr>

                    </div>
                </div>

                <div className="bg-light-grey text-center pb-25 ">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="artist-desc-text-main">
                                A one stop platform for artists to display, organize and sell their art. A global
                                platform
                                creating a strong community of artists and art lovers since 2016
                            </h2>
                            <a href="/how-to-sell">
                            <button className="view-all-btn hts-button mt-25 mb-25">HOW TO SELL</button>
                            </a>

                        </div>
                    </div>
                </div>

                <ArtistsAndArtworksSection title="TOP ARTISTS"
                    colored={false} artistSection={true}
                    artistData={this.state.topArtists} keyword="YMC Top" />
                <CategorySection title={"BROWSE ARTISTS BY TECHNIQUE"}
                    categoryData={techniques}
                    artistCategory={true}
                    colored={true} short_desc="Browse through artists around the world across all art techniques to your heart's content now!"
                    viewAll={true} keyWord="techniques" />
                <ArtistsAndArtworksSection title="FEATURED ARTISTS"
                    colored={false} artistSection={true}
                    artistData={this.state.Featured}
                    short_desc=" We carefully select artists from around the world for you to discover inspirational pieces from emerging and upcoming artists.
                    "
                    keyword="Featured" />
                <div className="container-rectangle-colored "
                    style={{ paddingBottom: "40px" }}>
                    <div className="rectangle-colored ">
                        <div style={{ display: "flex" }}>

                            <div className="title-featured-artworks text-uppercase">
                                Find Artist By ANY country
                                <hr className="line-category-name"></hr>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <p className="heading-desc-text">
                                    Find artists by their country and discover <br
                                    className="hidden-xss"/> their artworks.
                                </p>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-7">
                                        <CountryDropdown className="country-button"
                                                         style={{border: "1px #BEA57C !important"}}
                                                         value={this.state.country}
                                                         placeholder="Select your country"
                                                         onChange={(val) => this.selectCountry(val)}/>
                                    </div>
                                    <div className="col-md-5">
                                        <button onClick={() => {
                                         (!!this.state.country) ? this.handleViewAllCountry("country") : this.props.navigatorStore.openErrorModal("Please choose a country")}}
                                        className="masterpieces-primary-buttons button request-btn">
                                            SHOW ARTISTS
                                        </button>
                                    </div>
                                </div>


                                {/*<button style={{maxWidth: "60%", margin: "0px auto"}} onClick={() => {
                                    (!!this.state.country) ? this.handleViewAllCountry("country") : this.props.navigatorStore.openErrorModal("Please choose a country")
                                }} className="view-all-btn">
                                    <span>View All</span>
                                </button>*/}
                            </div>

                        </div>



                    </div>
                </div>
            </div>

        )
    }
}







// WEBPACK FOOTER //
// ./src/components/artist/artist.js